module.exports = __webpack_public_path__ + "static/img/icons_payments_blue.f84e4f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_payments_blue.svg
// module id = 4VZW
// module chunks = 1